import { Action, initialState, State } from "store/store";

export const rehydrate = (state: State = initialState, { data }: Action): State => {
  return { ...state, ...data };
};
